// extracted by mini-css-extract-plugin
export default {"full":"Virtual_full__VMNYJ","left":"Virtual_left__tKsys","wrapper":"Virtual_wrapper__jJVER"};